export default {
    dataDashBoard: state => state.dataDashBoard,
    listTypeDashBoard: state => state.listTypeDashBoard,
    listUserDashBoard: state => state.listUserDashBoard,
    listOptionsDashBoard: state => state.listOptionsDashBoard,
}